
import { LocalAssessmentData } from './assessmentLocalStorage';

// Validation des données avant sauvegarde
export const validateAssessmentData = (data: LocalAssessmentData): boolean => {
  console.log('🔍 [VALIDATION] Validating assessment data...', {
    hasAssessmentType: !!data.assessmentType,
    hasScores: !!data.scores && Object.keys(data.scores).length > 0,
    hasAnswers: !!data.answers && Object.keys(data.answers).length > 0,
    hasOverallScore: typeof data.overallScore === 'number'
  });

  if (!data.assessmentType) {
    console.error('❌ [VALIDATION] Missing assessmentType');
    return false;
  }

  if (!data.scores || Object.keys(data.scores).length === 0) {
    console.error('❌ [VALIDATION] Missing or empty scores');
    return false;
  }

  if (!data.answers || Object.keys(data.answers).length === 0) {
    console.error('❌ [VALIDATION] Missing or empty answers');
    return false;
  }

  if (typeof data.overallScore !== 'number') {
    console.error('❌ [VALIDATION] Invalid overallScore');
    return false;
  }

  console.log('✅ [VALIDATION] Assessment data is valid');
  return true;
};

// Transformer les scores au bon format pour la base de données
export const transformScoresForDatabase = (scores: Record<string, { score: number; maxScore: number }>): Record<string, number> => {
  const transformedScores: Record<string, number> = {};
  
  console.log('🔄 [TRANSFORM] Original scores structure:', scores);
  
  Object.entries(scores).forEach(([category, scoreData]) => {
    if (typeof scoreData === 'object' && scoreData !== null && 'score' in scoreData) {
      transformedScores[category] = scoreData.score;
      console.log(`🔄 [TRANSFORM] Transformed score for ${category}:`, scoreData.score);
    } else if (typeof scoreData === 'number') {
      transformedScores[category] = scoreData;
      console.log(`🔄 [TRANSFORM] Direct score for ${category}:`, scoreData);
    } else {
      console.warn(`⚠️ [TRANSFORM] Unexpected score format for ${category}:`, scoreData);
      transformedScores[category] = 0; // Fallback
    }
  });

  console.log('🔄 [TRANSFORM] Final transformed scores:', transformedScores);
  return transformedScores;
};
